<template>
    <div class="p-3">
        <form @submit.prevent="handleSubmit">
            <!-- Header -->
            <div class="mb-4">
                <h5 class="font-weight-bolder mb-1">
                    <i class="fas fa-key text-warning me-2"></i>
                    Credenciales de {{ portal.name }}
                </h5>
                <p class="text-sm text-secondary mb-0">
                    Usuario: <strong>{{ user.name }}</strong>
                    <span class="text-xxs d-block">{{ user.email }}</span>
                </p>
            </div>

            <!-- Alert for validation errors -->
            <div v-if="errorMessage" class="alert alert-danger text-white text-sm py-2 px-3 mb-3">
                <i class="fas fa-exclamation-circle me-2"></i>
                {{ errorMessage }}
            </div>

            <!-- Dynamic Fields -->
            <div class="row g-3">
                <div v-for="field in fields" :key="field.key"
                    :class="fields.length > 3 ? 'col-md-6' : 'col-12'">
                    <label :for="`field-${field.key}`" class="form-label fw-semibold text-sm">
                        <i v-if="field.type === 'password'" class="fas fa-lock text-info me-1"></i>
                        <i v-else-if="field.type === 'email'" class="fas fa-at text-primary me-1"></i>
                        <i v-else class="fas fa-font text-success me-1"></i>
                        {{ field.label }}
                        <span v-if="field.required" class="text-danger">*</span>
                    </label>
                    <input
                        :id="`field-${field.key}`"
                        v-model="formData[field.key]"
                        :type="field.type"
                        :placeholder="`Ingrese ${field.label.toLowerCase()}`"
                        :required="field.required"
                        :autocomplete="field.type === 'password' ? 'new-password' : 'off'"
                        class="form-control"
                    />
                </div>
            </div>

            <!-- Actions -->
            <div class="d-flex gap-3 justify-content-end mt-4 pt-3 border-top">
                <soft-button type="button" color="secondary" variant="outline" size="sm"
                    @click="$emit('cancel')" :disabled="isLoading">
                    <i class="fas fa-times me-1"></i> Cancelar
                </soft-button>
                <soft-button type="submit" color="success" variant="gradient" size="sm"
                    :disabled="isLoading">
                    <span v-if="isLoading">
                        <i class="fas fa-spinner fa-spin me-1"></i> Guardando...
                    </span>
                    <span v-else>
                        <i class="fas fa-save me-1"></i> Guardar
                    </span>
                </soft-button>
            </div>
        </form>
    </div>
</template>

<script>
import { ref, reactive } from "vue";
import SoftButton from "@/components/SoftButton.vue";

export default {
    name: "CredentialFormModal",
    components: { SoftButton },
    props: {
        portal: { type: Object, required: true },
        user: { type: Object, required: true },
        fields: { type: Array, required: true },
        existingData: { type: Object, default: null },
        isLoading: { type: Boolean, default: false },
    },
    emits: ['save', 'cancel'],
    setup(props, { emit }) {
        const errorMessage = ref("");

        // Initialize form data
        const initialData = {};
        props.fields.forEach(field => {
            initialData[field.key] = props.existingData?.[field.key] || '';
        });
        const formData = reactive(initialData);

        const handleSubmit = () => {
            errorMessage.value = "";

            // Basic validation for required fields
            for (const field of props.fields) {
                if (field.required && !formData[field.key]?.toString().trim()) {
                    errorMessage.value = `El campo "${field.label}" es obligatorio`;
                    return;
                }
            }

            emit('save', { ...formData });
        };

        return { formData, errorMessage, handleSubmit };
    }
};
</script>

<style scoped>
.gap-3 {
    gap: 1rem;
}
</style>
